import { render, staticRenderFns } from "./ConsultasDocsPorIrregularidade.vue?vue&type=template&id=431a9cd2&scoped=true&lang=pug&"
import script from "./ConsultasDocsPorIrregularidade.vue?vue&type=script&lang=js&"
export * from "./ConsultasDocsPorIrregularidade.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasDocsPorIrregularidade.vue?vue&type=style&index=0&id=431a9cd2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a9cd2",
  null
  
)

export default component.exports